"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelCaseToSpaceSeparatedString = void 0;
function camelCaseToSpaceSeparatedString(str) {
    const regex = /([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g;
    return str.replace(regex, '$1$4 $2$3$5').toLocaleLowerCase();
}
exports.camelCaseToSpaceSeparatedString = camelCaseToSpaceSeparatedString;
//# sourceMappingURL=camelCaseToSpaceSeparatedString.js.map